/*
  TKC product inquiry popup — pairs with snippets/tkc-inquiry-modal.liquid.

  One delegated click listener (capture phase) catches every Inquire button,
  so it also works for cards added later by filters / infinite scroll and for
  the quickview, whose content is swapped in by shop.js.
*/
(function () {
  var dialog = document.getElementById('tkc-inquiry');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var form = document.getElementById('tkc-inquiry-form');
  var formView = dialog.querySelector('[data-inquiry-form-view]');
  var doneView = dialog.querySelector('[data-inquiry-done]');
  var errorEl = dialog.querySelector('[data-inquiry-error]');
  var submitBtn = dialog.querySelector('[data-inquiry-submit]');
  var productBox = dialog.querySelector('[data-inquiry-product]');
  var imgEl = dialog.querySelector('[data-inquiry-img]');
  var titleEl = dialog.querySelector('[data-inquiry-title]');
  var skuLabel = dialog.querySelector('[data-inquiry-sku-label]');
  var doneTitle = dialog.querySelector('[data-inquiry-done-title]');
  var field = function (name) { return form.querySelector('[data-inquiry-field="' + name + '"]'); };

  var BUTTON_SELECTOR = '.inquiryBtn, .inquireBtn, .inquireBtn-ice, .inquireBtn-gc, .inquireBtn-cc';
  var FLAG_KEY = 'tkcInquiryPending';
  var lastQuickviewHandle = null;
  var pdpData = null;
  try {
    var pdpEl = document.getElementById('tkc-inquiry-pdp');
    if (pdpEl) pdpData = JSON.parse(pdpEl.textContent);
  } catch (e) { pdpData = null; }

  function handleFromHref(href) {
    var m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Card Inquire sits inside .cart-btn; clicks on the pill padding land on
  // .cart-btn itself, so treat a .cart-btn that wraps an inquiry label as the button.
  function findInquiryButton(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest(BUTTON_SELECTOR);
    if (btn) return btn;
    var cartBtn = target.closest('.cart-btn');
    if (cartBtn && cartBtn.querySelector('.inquiryBtn')) return cartBtn;
    return null;
  }

  function resolveContext(btn) {
    var qv = btn.closest('#qvPopupModal');
    if (qv) {
      var qvQty = qv.querySelector('input[name="quantity"]');
      var qvVariant = document.getElementById('qv-variantid');
      return {
        handle: lastQuickviewHandle,
        qty: qvQty && qvQty.value,
        variantId: qvVariant && qvVariant.value
      };
    }

    // Product cards (collections, search, homepage) and the homepage deal block.
    var card = btn.closest('.card-wrapper, .productdeal');
    if (card) {
      var opener = card.querySelector('[data-handle]');
      var link = card.querySelector('a[href*="/products/"]');
      var handle = (opener && opener.getAttribute('data-handle')) || (link && handleFromHref(link.getAttribute('href')));
      var variantEl = card.querySelector('[data-variantid]');
      if (handle) return { handle: handle, variantId: variantEl && variantEl.getAttribute('data-variantid') };
    }

    // Product page purchase area.
    if (pdpData) {
      var scope = btn.closest('.product__info-container, .product, section') || document;
      var qtyInput = scope.querySelector('input[name="quantity"]');
      var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      return { handle: pdpData.handle, qty: qtyInput && qtyInput.value, variantId: idInput && idInput.value, pdp: true };
    }

    return { handle: handleFromHref(window.location.pathname) };
  }

  function fillProduct(p, ctx) {
    var variants = p.variants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(ctx.variantId)) { variant = variants[i]; break; }
    }
    variant = variant || variants[0] || {};

    var title = p.title || '';
    if (variant.title && variant.title !== 'Default Title') title += ' — ' + variant.title;
    var url = p.url ? window.location.origin + p.url.split('?')[0] : window.location.href;

    field('product').value = title;
    field('sku').value = variant.sku || '';
    field('variant').value = variant.id || '';
    field('url').value = url;

    titleEl.textContent = title;
    skuLabel.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
    doneTitle.textContent = p.title || 'this product';
    var img = p.image || p.featured_image;
    if (img) {
      imgEl.src = img.indexOf('//') === 0 ? 'https:' + img : img;
      imgEl.alt = p.title || '';
      imgEl.hidden = false;
    } else {
      imgEl.hidden = true;
    }
    productBox.hidden = !title;
  }

  function resetForm() {
    formView.hidden = false;
    doneView.hidden = true;
    errorEl.hidden = true;
    submitBtn.disabled = false;
    submitBtn.classList.remove('is-loading');
    form.querySelector('textarea').value = '';
    ['product', 'sku', 'variant', 'url'].forEach(function (n) { field(n).value = ''; });
    productBox.hidden = true;
  }

  function open(ctx) {
    resetForm();
    var qty = parseInt(ctx.qty, 10);
    field('qty').value = qty > 0 ? qty : 1;

    if (ctx.pdp && pdpData) {
      fillProduct(pdpData, ctx);
    } else if (ctx.handle) {
      fetch('/products/' + encodeURIComponent(ctx.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) fillProduct(p, ctx); })
        .catch(function () {});
      // Fallback so the email still says which product, even if the fetch fails.
      field('url').value = window.location.origin + '/products/' + ctx.handle;
      field('product').value = ctx.handle;
    } else {
      field('url').value = window.location.href;
    }

    dialog.showModal();
    var firstEmpty = Array.prototype.filter.call(form.querySelectorAll('input[required]'), function (i) { return !i.value.trim(); })[0];
    (firstEmpty || form.querySelector('textarea')).focus();
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function showDone() {
    formView.hidden = true;
    doneView.hidden = false;
    var closeBtn = doneView.querySelector('[data-inquiry-close]');
    if (closeBtn) closeBtn.focus();
  }

  // Remember which product the quickview is showing (shop.js reads data-handle too).
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('quickview-opener [data-handle], quickview-opener[data-handle], .quick-view[data-handle]');
    if (opener) lastQuickviewHandle = opener.getAttribute('data-handle');
  }, true);

  // Capture phase so card links / product forms never navigate or submit.
  document.addEventListener('click', function (e) {
    var btn = findInquiryButton(e.target);
    if (!btn || btn.closest('#tkc-inquiry')) return;
    e.preventDefault();
    e.stopPropagation();
    open(resolveContext(btn));
  }, true);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog || (e.target.closest && e.target.closest('[data-inquiry-close]'))) close();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    var name = form.querySelector('[name="contact[name]"]');
    var email = form.querySelector('[name="contact[email]"]');
    if (!name.value.trim()) { showError('Please enter your name.'); name.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { showError('Please enter a valid email address.'); email.focus(); return; }

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');

    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (res.url.indexOf('/challenge') !== -1) {
          // Shopify wants a captcha: fall back to a normal submit, which shows the
          // challenge page and then returns with ?contact_posted=true.
          try { sessionStorage.setItem(FLAG_KEY, field('product').value || '1'); } catch (err) {}
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        if (res.ok && res.url.indexOf('contact_posted=true') !== -1) {
          showDone();
          return;
        }
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('.errors, .form__message, .form-message--error');
          showError(err && err.textContent.trim() ? err.textContent.trim() : 'Sorry, something went wrong. Please try again or email us directly.');
        });
      })
      .catch(function () {
        showError('Could not send right now. Please check your connection and try again.');
      })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      });
  });

  // Returning from the captcha fallback: confirm the inquiry was sent.
  try {
    var pending = sessionStorage.getItem(FLAG_KEY);
    if (pending && /contact_posted=true/.test(window.location.search)) {
      sessionStorage.removeItem(FLAG_KEY);
      resetForm();
      doneTitle.textContent = pending !== '1' ? pending : 'this product';
      dialog.showModal();
      showDone();
    }
  } catch (err) {}
})();
